import { Box, Button, Divider, Grid, TextareaAutosize, Typography, CircularProgress } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSupportRequestDetails, submitSupportTicketResponse, downloadSupportDocument, uploadSupportDocuments, deleteSupportDocuments } from '../../../actions';
import { getAppSource, getUserType, maskLoan, renderDefaultMsg, isAdminCheck, isAdmin } from '../../../helpers';
import { styled } from '@material-ui/core/styles';
import { FILE_LENGTH, FILE_LENGTH_LIMIT } from '../../../helpers/constants';
import { TicketReopenPopup } from '../TicketReopenPopup';
import { ReopenTicketSuccessPopup } from '../ReopenTicketSuccessPopup';
import { DeleteConfirmation } from '../../ManageBankAccount/DeleteConfirmationOnAccount/DeleteConfirmation';
import { FileSizeAlert } from '../../PayoffRequest/FileSizeAlert';
import { FileExtensionAlert } from '../../IdentityThefts/FileExtensionAlert';
import { SupportFeedback } from '../SupportFeedback';

import { decrypt } from '../../../helpers/encrypt';
import { useStyles } from './styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import infoIcon from '../../../assets/RequestDocument/Info.png';

import ClarificationNeeded from '../../../assets/RequestDocument/ClarificationNeeded.svg';
import Completed from '../../../assets/RequestDocument/Completed.svg';
import InProgress from '../../../assets/RequestDocument/InProgress.svg';
import pdfIcon from '../../../assets/SupportTicket/pdfIcon.svg';
import jpgIcon from '../../../assets/SupportTicket/jpgIcon.svg';
import pngIcon from '../../../assets/SupportTicket/pngIcon.svg';
import Pending2 from '../../../assets/RequestDocument/Pending2.svg';
import Pending3 from '../../../assets/RequestDocument/Pending3.svg';
import SubmittedYellow from '../../../assets/RequestDocument/SubmittedYellow.svg';
import imageIcon from '../../../assets/image.png';

import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Pagination from '@material-ui/lab/Pagination';
import Cookies from 'js-cookie';
import moment from 'moment';
import './index.css';

const useStyles1 = makeStyles((theme) => ({
  stepIcon: {
    marginTop: '-10px',
    padding: '5px'
  },
}));

const CustomStepIcon = (props, label, status) => {
  const classes = useStyles1();
  const { active, completed = true, icon } = props;

  // Define custom icons for active and completed steps
  let displayedIcon = SubmittedYellow;
  if (status === 'Submitted') {
    if (icon === 1) {
      displayedIcon = SubmittedYellow;
    }
    else if (icon === 2) {
      displayedIcon = Pending2;
    }
    else if (icon === 3) {
      displayedIcon = Pending3;
    }
  }
  else if (status === 'In Progress') {
    if (icon === 1) {
      displayedIcon = Completed;
    }
    else if (icon === 2) {
      displayedIcon = InProgress;
    }
    else if (icon === 3) {
      displayedIcon = Pending3;

    }
  }  
  else if (status === 'Info Awaited') {
    if (icon === 1) {
      displayedIcon = Completed;
    }
    else if (icon === 2) {
      displayedIcon = InProgress;
    }
    else if (icon === 3) {
      displayedIcon = Pending3;

    }
  }
  else if (status === 'Reopen') {
    if (icon === 1) {
      displayedIcon = Completed;
    }
    else if (icon === 2) {
      displayedIcon = Pending2;
    }
    else if (icon === 3) {
      displayedIcon = Pending3;

    }
  }
  else if (status === 'Clarification Needed') {
    if (icon === 1) {
      displayedIcon = Completed;
    }
    else if (icon === 2) {
      displayedIcon = ClarificationNeeded;
    }
    else if (icon === 3) {
      displayedIcon = Pending3;
    }
  }
  else if (status === 'Completed') {
    if (icon === 1) {
      displayedIcon = Completed;
    }
    else if (icon === 2) {
      displayedIcon = Completed;
    }
    else if (icon === 3) {
      displayedIcon = Completed;
    }
  }
  // Use the Warning icon for incomplete steps

  return (
    <div
      style={{ marginTop: '-10px', padding: '5px' }}
    >      <img src={displayedIcon} />
    </div>
  );
};
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
export const Requests =  React.memo((props) => {

  const { accountNumber, requestLists = [] } = props;

  const theme = useTheme();
  const classes = useStyles();
  const componentRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'));
  const [loader, setLoader] = useState(false);
  const [documentLists, setDocumentList] = useState([]);
  const [userComment, setUserComment] = useState();
  const [openClassification, setOpenClassification] = useState(false);
  const [page, setPage] = React.useState(1);
  const [errorMsg, setErrorMsg] = useState("");
  const [commentStatus, setCommentStatus] = useState(false);
  const [commentDocs, setCommentDocs] = useState([]);
  const [counter, setCounter] = useState(1);
  const [file, setFilesName] = useState('');
  const [fileLengthStatus, setFileLengthStatus] = useState(false);
  const [errMessage, setErrorMessage] = useState('');
  const [reopenPopup, setReopenPopup] = useState(false);
  const [supportTicketId, setSupportTicketId] = useState();
  const [reopenTicketSuccess, setReopenTicketSuccess] = useState(false);
  const [supportTicketDetails, setSupportTicketDetails] = useState();
  const [documentId, setDocumentIds] = useState(0);
  const [alertStatus, setAlertStatus] = useState(false);
  const [specialChar, setFileContainSpecialChar] = useState(false);
  const [replaceIndex, setReplaceIndex] = useState();
  const [deleteStatus, setDeletePopup] = useState(false);
  const [ticketIndex, setIndex] = useState();
  const [fileUploadLoader, setFileUploadLoader] = useState(false);
  const [isDescriptionExpanded, setDescriptionExpanded] = useState(false);
  const [allowedExtensionsStatus, setAllowedExtensionsStatus] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState(false);
  const [ticketId, setTicketId] = useState(0);
  const userName = isAdmin() ? 'Borrower' : Cookies.get('firstLastName')
  const autoOpenRef = useRef(null);
     
  const handleExtensionAlertClose = () => setAllowedExtensionsStatus(false)

  const handleChange = (event, value) => {
    setPage(value);
    window.scrollTo(0, 0);
    props.onNextClick(value)
  };

  useEffect(() => {
    if (requestLists) {

      const tempObj = [{
        agentName: '',
        comment: '',
        commentByAgent: false,
        createdDateTime: moment(new Date()).format('MM/DD/YYYY')
      }, {
        agentName: '',
        comment: '',
        commentByAgent: false,
        createdDateTime: moment(new Date()).format('MM/DD/YYYY')
      }]
      let requestList = requestLists.map((data) => {
        data['clarificationHistory'] = [...tempObj];
        return data;
      });
      const latestCompleted = requestList
        .filter((t) => t.status === 'Completed')
        .reduce((latest, t) => {
          if (!latest) return t;
          return moment(t.updatedDate).isAfter(moment(latest.updatedDate)) ? t : latest;
        }, null);
      if (latestCompleted) {
        autoOpenRef.current = { key: latestCompleted, index: requestList.indexOf(latestCompleted) };
      }
      setDocumentList(requestList)
      setPage(props?.paginationData?.pageNumber);
    }
  }, [props?.paginationData?.pageNumber, requestLists]);

  useEffect(() => {
    if (autoOpenRef.current && documentLists.length > 0) {
      const { key, index } = autoOpenRef.current;
      autoOpenRef.current = null;
      setStatusValue(key, index);
    }
  }, [documentLists]);
 
  const getSteps = (details) => {
    var stepperStatus = [];
    stepperStatus = [{ status: details.isReopen ? 'Reopen' : 'Submitted', createdDateTime: null }, { status: 'In Progress', createdDateTime: null }, { status: 'Completed', createdDateTime: null }];
    let index = details.requestStatusHistory.findIndex(element => element.status === "Clarification Needed")
    let completedStatus = details.requestStatusHistory.findIndex(element => element.status === "Completed")

    if (completedStatus !== -1) {
      setCommentStatus(true)
    } else {
      setCommentStatus(false)
    }

    if (index !== -1) {
      stepperStatus[1].status = 'Clarification Needed'
    } else {
      stepperStatus[1].status = 'In Progress'
    }

    let stepperData = stepperStatus.map((e) => {
      let temp = details.requestStatusHistory.find(element => element.status === e.status)
      if (temp) {
        e.createdDateTime = temp.createdDateTime;
      }
      return e;
    })
    return stepperData;
  }

  const handleFeedbackSubmit = () => {
    setFeedbackStatus(false)
    let newDocLists = [...documentLists]
    newDocLists[ticketIndex]['isFeedbackDone'] = true;
    setDocumentList(newDocLists)
  }

  const handleCancelIcon = () => {
    setFeedbackStatus(false)
  }

  const setStatusValue = async (key, index) => {
    setIndex(index)
    setSupportTicketDetails(key)
    setSupportTicketId(key.supportRequestId)

    if (key?.openStatus) {
      let newDocLists = [...documentLists]
      newDocLists = newDocLists.map((data) => {
        if (data.supportRequestId === key?.supportRequestId) {
          data['openStatus'] = false;
          const agentData = data?.clarificationHistory.filter((data) => data.commentByAgent === true)
          agentData.map((val, index, rows) => {
            if (index === 0) {
              data['completedMessage'] = val.comment;
            }
          })
        }
        return data;
      })
      setDocumentList(newDocLists)
    } else {
      const data = {
        "supportRequestId": key?.supportRequestId,
        "accountNumber": null,
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": ""
      };

      const res = await getSupportRequestDetails(data);
      if (res?.responseData.lstResponseStatus[0]?.statusCode == 0) {
        const details = res?.responseData?.responseData;
        let newDocLists = [...documentLists]
        newDocLists = newDocLists.map((data) => {
          data['openStatus'] = false;
          return data;
        })
        newDocLists = newDocLists.map((data) => {
          if (data.supportRequestId == key?.supportRequestId) {
            data['openStatus'] = true;
            data['isReopen'] = details?.isReopen;
            data['completedDate'] = details?.completedDate;
            data['description'] = details?.description;
            data['statusHistory'] = details?.requestStatusHistory;
            data['requestStatusHistory'] = getSteps(details);
            data['clarificationHistory'] = [...details?.clarificationHistory.reverse()];
            data['documentPath'] = details?.documentPath;
            data['documents'] = details?.documents;
            if ((data['status'] === 'Clarification Needed') || (data['status'] === 'Info Awaited') || ((data['status'] === 'Completed') && (details.documentPath == null)))
              setOpenClassification(true);
            else
              setOpenClassification(false);

            const agentData = data?.clarificationHistory.filter((data) => data.commentByAgent === true)
            agentData?.map((val, index, rows) => {
              if (index === 0) {
                data['completedMessage'] = val.comment;
              }
            })
          }

          return data;
        })
        setUserComment(null)
        setDocumentList(newDocLists);

      }
    }
  }
  const totalPages = Math.ceil( props?.paginationData?.totalRecord / props?.paginationData?.pageSize);

  const applyStatusTextColor = (key) => {
    if ((key?.status == 'Submitted') || (key?.status == 'Reopen')) {
      return '#F59720'
    } else if ((key?.status == 'In Progress') || (key?.status == 'Info Awaited')) {
      return '#007FFF'
    } else if (key?.status == 'Clarification Needed') {
      return '#E02020'
    } else if (key?.status == 'Completed') {
      return '#198100'
    }
  }

  const applyStatusBgColor = (key) => {
    if ((key?.status == 'Submitted') || (key?.status == 'Reopen')) {
      return '#FDEAD2'
    } else if (key?.status == 'Clarification Needed') {
      return '#F9D2D2'
    } else if ((key?.status == 'In Progress') || (key?.status == 'Info Awaited')) {
      return '#CCE5FF'
    } else if (key?.status == 'Completed') {
      return '#D1E6CC'
    }
  }

  const calculateCommentLenth = () => {
    const length = userComment?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const setUserCommentList = (event) => {
    setUserComment(event.target.value.replace(/^\s+/, ''))
  }

  const openClass = () => {
    setOpenClassification(!openClassification)
  }

  const handleSubmit = async (index, key) => {
    const data = {
      "supportRequestId": key?.supportRequestId,
      "comment": userComment,
      "isReopen": false,
      "documentId": commentDocs.map((key) => key.documentId),
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    setLoader(true)
    const res = await submitSupportTicketResponse(data);
    if (res?.responseData.lstResponseStatus[0]?.statusCode == 0) {
      const obj = {
        agentName: '',
        comment: userComment,
        commentByAgent: false,
        createdDateTime: moment(new Date()).format('MM/DD/YYYY'),
        documents: commentDocs
      }
      setLoader(false)
      let newDocLists = [...documentLists]
      newDocLists = newDocLists.map((data) => {
        if (data.supportRequestId === key?.supportRequestId) {
          data['clarificationHistory'].unshift(obj);
          data['status'] = 'In Progress';
          data['requestStatusHistory'][1]['status'] = 'In Progress';
          data['requestStatusHistory'][1]['createdDateTime'] = moment(new Date()).format('MM/DD/YYYY');
        }
        return data;
      })
      setDocumentList(newDocLists);
      setUserComment('');
      setCommentDocs([])
    }
  }

  const getAbbrevation = (word) => {
      const bits = word.trim().split(' ');
      return bits
        .map((bit) => bit.charAt(0))
        .join('')
        .toUpperCase();
  }

  const downloadDocuments = async (docName, documentId) => {
    const response = await downloadSupportDocument(props.accountNumber, documentId)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', docName);
      document.body.appendChild(link);
      link.click();

      if (docName.includes('pdf')) {
        var a = document.createElement('a');
        a.target="_blank";
        a.href = url;
        a.click();
      }
    }
  }

  const handleInputFile = (e) => {
    e.target.value = null;
  }

   const handleFile = (event, replace) => {
      var allowedExtensions = /(\.png|\.jpg|\.pdf|\.jpeg)$/i;
      var specialCharacters =  /[\/:*?“<>|]/;
      var fileSize =  event.target.files[0].size / 1024 / 1024
      if (fileSize > 5) {
        setFilesName(event.target.files[0].name)
        setAlertStatus(true)
      } else if (!allowedExtensions.exec(event.target.value)) { 
        setFilesName(event.target.files[0].name)
        setAllowedExtensionsStatus(true)
      } else if (event.target.files[0].name.length > FILE_LENGTH_LIMIT) {
        setFilesName(event.target.files[0].name)
        setFileLengthStatus(true)
      }  else if (specialCharacters.test(event.target.files[0].name)) {
        setFilesName(event.target.files[0].name)
        setFileContainSpecialChar(true) 
      } else {
        onFileUpload(event.target.files[0], replace)
      }
    };
  
    const onFileUpload = async (file, replace) => {
      setFileUploadLoader(true)
      setErrorMessage('');
      const res = await uploadSupportDocuments(props.accountNumber, file, commentDocs.length, replace, counter);
      if (res && res?.responseData?.lstResponseStatus && (res?.responseData.lstResponseStatus[0]?.statusCode == '0')) { 
        setFileUploadLoader(false)
        setCounter(counter + 1)
        let newObj = [...commentDocs]
        newObj.push({documentName: file.name, documentId: res.responseData.responseData})
        setCommentDocs(newObj)
      } else if (res && res?.responseData?.lstResponseStatus && res?.responseData.lstResponseStatus[0]?.statusCode !== "0") {
        setFileUploadLoader(false)
        setErrorMessage(res.lstResponseStatus[0].statusDesc)
        scrollTop()
      } else {
        setFileUploadLoader(false)
        setErrorMessage(renderDefaultMsg('400'));
        scrollTop()
     }
    };

    const closeReopenPopup = () => {
      setReopenPopup(false)
    }

    const submitReopenTicket = () => {
      setReopenPopup(false)
      setReopenTicketSuccess(true)
      getReopenTicketDetails(supportTicketDetails)
    }

    const getReopenTicketDetails = async (key) => {
      setSupportTicketDetails(key)
      setSupportTicketId(key.supportRequestId)
        const data = {
          "supportRequestId": key?.supportRequestId,
          "accountNumber": null,
          "privateLabelUrl": Cookies.get("privateLabelUrl"),
          "ipAddress": Cookies.get('publicIp'),
          "browser": Cookies.get("browser"),
          "appSource": getAppSource(),
          "userType": getUserType(),
          "userName": ""
        };
  
        const res = await getSupportRequestDetails(data);
        if (res?.responseData.lstResponseStatus[0]?.statusCode == 0) {
          const details = res?.responseData?.responseData;
          let newDocLists = [...documentLists]
          newDocLists = newDocLists.map((data) => {
            data['openStatus'] = false;
            return data;
          })
          newDocLists = newDocLists.map((data) => {
            if (data.supportRequestId == key?.supportRequestId) {
              data['openStatus'] = true;
              data['isReopen'] = details?.isReopen;
              data['completedDate'] = details?.completedDate;
              data['description'] = details?.description;
              data['statusHistory'] = details?.requestStatusHistory;
              data['requestStatusHistory'] = getSteps(details);
               data['clarificationHistory'] = [...details?.clarificationHistory.reverse()];
              data['documentPath'] = details?.documentPath;
              data['documents'] = details?.documents;
              if ((data['status'] === 'Clarification Needed') || ((data['status'] === 'Completed') && (details.documentPath == null)))
                setOpenClassification(true);
              else
                setOpenClassification(false);
  
              const agentData = data?.clarificationHistory.filter((data) => data.commentByAgent === true)
              agentData?.map((val, index, rows) => {
                if (index === 0) {
                  data['completedMessage'] = val.comment;
                }
              })
            }
  
            return data;
          })
          setUserComment(null)
          setDocumentList(newDocLists);
  
        }
    }

    const handleGotIt = () => {
      setReopenTicketSuccess(false)
      let newDocLists = [...documentLists]
      newDocLists[ticketIndex]['status'] = 'Reopen';
      newDocLists[ticketIndex]['updatedDate'] =  moment(new Date()).format('MM/DD/YYYY');
      setDocumentList(newDocLists)
    }

    const shortText = (text) => {
      if (text !== '') {
        return text.length < 25 ? text : text.substr(0, 25) + '...'
      } else {
        return text
      }
    }

    const deleteDoc = (id, index, name) => {
      setReplaceIndex(index)
      setDocumentIds(id)
      setDeletePopup(true)
      setFilesName(name)
    }
  
    const handleClose = () => {
      setDeletePopup(false)
    }
  
    const handleDeleteDoc = () => {
      deleteDocuments(documentId)
    }
    
    const deleteDocuments = async (id) => {
      const response = await deleteSupportDocuments(props.accountNumber, id)
      if (response && response?.responseData?.lstResponseStatus && response?.responseData.lstResponseStatus[0]?.statusCode == 0) {  
        setDeletePopup(false)
        let newObj = [...commentDocs];
        newObj.splice(replaceIndex, 1);
        setCommentDocs(newObj)
        setDocumentIds()
        setReplaceIndex()
      }  else if (response && response?.responseData?.lstResponseStatus && response?.responseData.lstResponseStatus[0]?.statusCode !== "0") {
        setErrorMsg(response.lstResponseStatus[0].statusDesc)
      } else {
        setErrorMessage(renderDefaultMsg('400'));
      }
    } 

    const handleAlertClose = () => {
      setAlertStatus(false)
    }

    const handleViewMore = (catIndex, index, status) => {
      let newDocLists = [...documentLists]
      newDocLists[catIndex]['clarificationHistory'][index]['isCommentExpanded'] = status
      setDocumentList(newDocLists)
    }

    const handleGiveFeedback = (key, ind, e) => {
      e.stopPropagation();
      setIndex(ind)
      setTicketId(key.supportRequestNumber);
      setFeedbackStatus(true)
    }

  return (
    <CssBaseline>
      <Box container="true" maxWidth='xl' className={classes.root} >
        <Box ref={componentRef}>

          <Grid container className={classes.accordianContainer}>
            <Grid item md={12} xs={12} lg={12}>

              <Box style={{ paddingBottom: '20px' }}>

                {documentLists?.map((key, index) => {
                  return (
                    <Box className={`${classes.accordian} ${'acc'}`} key={key.supportRequestNumber}>
                      <Accordion elevation={0} expanded={key?.openStatus == true} onChange={() => setStatusValue(key, index)}>
                        <AccordionSummary
                          style={{ flexDirection: "row-reverse" }}
                          expandIcon={<ExpandMoreIcon className={classes.expand_icon} />}
                          aria-controls={`panel${index}c-content`}
                          id={`panel${index}c-header`}
                          className={classes.transactionText}
                        >

                          <Grid container>
                            <Grid item md={12} xs={12} lg={12}>

                              <Grid container>
                                <Grid item md={3} xs={3} lg={3} style={{ margin: 'auto' }}>
                                  <Box>
                                    <Box className={classes.requestId}>Ticket #{key?.supportRequestNumber}</Box>
                                    <Box className={classes.documentType}>{key?.categoryType} {(!mediaQuery && (props?.accounts.length > 1)) && <> | Loan {maskLoan(decrypt(key?.accountNumber))} </>} </Box>                   
                                  </Box>
                                </Grid>
                                 <Grid item md={4} xs={3} lg={4} style={{ margin: 'auto' }}>
                                  <Box>
                                    {(key?.status === 'Completed') && !key?.openStatus &&
                                      <Box className={classes.resolutionDetails}><a className={classes.clickLink} onClick={(e) => { e.stopPropagation(); setStatusValue(key, index); }}>Click to see resolution details</a></Box>}
                                  </Box>
                                </Grid>
                                <Grid item md={2} xs={3} lg={2} style={{ margin: 'auto' }}>
                                 {!key?.isFeedbackDone && (key?.status == 'Completed') &&
                                      <a className={classes.clickLink} onClick={(e) => handleGiveFeedback(key, index, e)}> Give Feedback</a>}
                                </Grid>    
                                <Grid item md={3} xs={3} lg={3} style={{ margin: 'auto' }}>
                                  <Box>
                                 
                                    <Box className={classes.transferBox} style={{ color: applyStatusTextColor(key), backgroundColor: applyStatusBgColor(key) }}>{key?.status?.toLowerCase() == "info awaited" ? 'In Progress' : key.status}</Box>
                                    {(key?.status == 'Completed') ?
                                      <Box className={classes.documentDate}>Archive in {key?.archiveDays} days</Box> :
                                      (key?.status !== 'Completed') && (key?.status !== 'Clarification Needed') && (moment(key?.dueDate).format('MM/DD/YYYY') > moment(new Date()).format('MM/DD/YYYY')) ? <Box className={classes.documentDate}>Estimated Resolution: {moment(key?.dueDate).format('MM/DD/YYYY')}</Box> : null
                                    }

                                  </Box>
                                </Grid>
                              </Grid>

                            </Grid>
                          </Grid>

                        </AccordionSummary>
                        <AccordionDetails >
                          <Box className={classes.accDetails}>
                            <Box>
                              {key?.requestStatusHistory &&
                                <Stepper activeStep={key?.statusHistory?.length - 1} alternativeLabel>
                                  {key?.requestStatusHistory.map((label, index) => (
                                    <Step key={label} >
                                      <StepLabel StepIconComponent={(props) => CustomStepIcon(props, label, key?.status)} status={label} step={index} >
                                        <Box>
                                          <Box className={(label?.createdDateTime !== null) ? classes.label : classes.labelFade}>{label.status}</Box>
                                          {label?.createdDateTime !== null && <Box className={classes.date}>{moment(label.createdDateTime).format('MM/DD/YYYY')}</Box>}
                                          
                                        </Box>
                                      </StepLabel>
                                    </Step>
                                  ))}
                                </Stepper>
                              }
                            </Box>

                            <Box className={classes.detailsSection}>
                              <Grid container>
                                <Grid item md={9} xs={3} lg={9}>
                                   <Box className={classes.details}>Ticket Details</Box>
                                  </Grid>
                                  <Grid item md={3} xs={9} lg={3}>
                                  {((key?.status == 'Completed') && !key.isReopen && (moment(key.completedDate).add(6, 'day') > new Date())) &&
                                    <Button
                                      className={classes.reopenBtn}
                                      variant="contained"
                                      onClick={() => setReopenPopup(true)}
                                      color="primary">
                                      Reopen Ticket</Button>}
                                  </Grid>
                                </Grid> 

                              <Box className={classes.documentDetails}>
                                <Grid container>
                                  <Grid item md={12} lg={12} xs={12} >
                                    <Box>
                                    
                                        <Grid container>
                                         
                                          <Grid item md={12} xs={12} lg={12}>
                                          {key?.description && (
                                                <Box className={classes.documentValue}>
                                                    {isDescriptionExpanded ? (
                                                      <span
                                                              dangerouslySetInnerHTML={{ __html: key.description }}
                                                            />
                                                          ) : (
                                                      <span
                                                        dangerouslySetInnerHTML={{
                                                          __html: (key.description.length > 250) ?  `${key.description.substring(0, 250)}...` : 
                                                          key.description,
                                                        }}
                                                      />
                                                    )}
                                                
                                                    {key.description.length > 250 && (
                                                <span
                                                  onClick={() => setDescriptionExpanded(!isDescriptionExpanded)}
                                                  className={classes.view}
                                                >
                                                        {isDescriptionExpanded ? ' View Less' : 'View More'}
                                                </span>
                                                    )}
                                                </Box>
                                                )}
                                          </Grid>
                                        </Grid>

                                     {(key?.documents?.length > 0) && <Grid container>
                                        
                                        <Grid item md={12} xs={12} lg={12}>
                                          <Box className={classes.documentValue1}>
                                          {key?.documents.map((doc, index) => (
                                            <Typography className={classes.fileName} onClick={() => downloadDocuments(doc.documentName, doc?.documentId)}><img src={doc.documentName.includes('.pdf') ? pdfIcon : imageIcon} style={{ marginRight: '10px' }} />{doc.documentName}</Typography>))}
                                          </Box>
                                        </Grid>
                                      </Grid> }
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Box>

                            {key?.clarificationHistory.length > 0 && <Box className={classes.clarificationSection}>

                           
                              <Box className={classes.details1}><ExpandMoreIcon className={`${openClassification ? classes.collapse_icon : classes.expand_icon}`} onClick={openClass} /> <span className={classes.requestHistory} onClick={openClass} >Ticket History</span></Box>
                                  
                              {openClassification && <Box className={classes.documentDetails}>
                                {key?.clarificationHistory.map((commentData, i) => {

                                  return (<Grid container>
                                    <Grid item md={12} lg={12} xs={12} style={{ marginBottom: '15px' }} >
                                      <Box>
                                        <Grid container>
                                          {((-1 === i - 1) && (key.status == 'Clarification Needed')) && <Grid item xs={12} sm={12} md={12}>
                                            <Grid item xs={12} sm={12} md={6} style={{ display: 'flex', marginTop: '10px' }}>
                                              <Grid xs={2} sm={2} md={1}>

                                                {<Typography className={classes.nameTagUN}>
                                                  <span className='text'>{getAbbrevation(userName)}</span>
                                                </Typography>}
                                              </Grid>

                                              <Grid xs={10} sm={10} md={10} style={{ display: 'flex' }}>
                                                <Typography className={classes.headingText}>{userName}</Typography>
                                                <Typography className={classes.headingDate}>{moment(new Date()).format('MM/DD/YYYY')}</Typography>
                                              </Grid>
                                            </Grid>

                                            <Box className={`${classes.agentComment} wdt`}>
                                              <Box className={classes.textareaSection}>
                                                <TextareaAutosize
                                                  style={{ height: '56px' }}
                                                  color="primary"
                                                  id={`outlined_impacted250`}
                                                  variant="outlined"
                                                  type="text"
                                                  name="comments"
                                                  autoFocus
                                                  maxLength="1000"
                                                  onChange={(event) => setUserCommentList(event)}
                                                  value={userComment}
                                                  placeholder='Please include all clarifications in a single comment, as only one comment is allowed'
                                                  className={classes.textArea}
                                                />
                                                <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/1000</Typography>
                                                <Box className={classes.fileUpload}>
                                                  <Box className={classes.chooseFile}>
                                                    Attach a file (Optional):
                                                  </Box>
                                                  <Box>
                                                  <input
                                                      accept=".pdf, .png, .jpg, .jpeg"
                                                      type="file"
                                                      name='selectedFile'
                                                      style={{display: 'none'}}
                                                      id="upload-button"
                                                      onClick={(e) => handleInputFile(e)}
                                                      onChange={(e) => handleFile(e, true)}
                                                      
                                                    />
                                                    {/* <Button component="label" variant="contained" className={classes.fileButton} disabled={(commentDocs.length == 1)}>
                                                      CHOOSE FILE
                                                      <VisuallyHiddenInput type="file"  accept=".pdf, .png, .jpg, .jpeg" onClick={(e) => handleInputFile(e)}
                                                      onChange={(e) => handleFile(e, false)} />
                                                    </Button> */}
                                                    {fileUploadLoader ? 
                                                      <Button component="label" type='submit' className={classes.fileButton} variant="contained" color='primary'>
                                                        <CircularProgress color='primary' />
                                                      </Button>
                                                    :
                                                    <Button component="label" variant="contained" className={(commentDocs.length == 1) ? classes.disableFileBtn : classes.fileButton} disabled={(commentDocs.length == 1)}>
                                                      <Box className={(commentDocs.length == 1) ? classes.disableChooseBtn : classes.chooseFile}>CHOOSE FILE</Box>
                                                      <VisuallyHiddenInput type="file"  accept=".pdf, .png, .jpg, .jpeg" onClick={(e) => handleInputFile(e)}
                                                      onChange={(e) => handleFile(e, false)} />
                                                    </Button> }

                                                  </Box>
                                                  <Box className={`${classes.chooseFile} info`} >
                                                     Only 1 file(PDF, JPG, PNG, JPEG) allowed of 5 MB
                                                  </Box>
                                                </Box>                                              

                                                <Grid container >
                                                  { (commentDocs.length > 0) && commentDocs.map((key, ind) => {  
                                                    return (
                                                      <Grid item xs={12} sm={12} md={4}>
                                                        <Box className={classes.uploadedImageContainer}>
                                                          <Box className={classes.uploadedImage}>
                                                              <img className={classes.checkImg} src={key.documentName.includes('.pdf') ? pdfIcon : imageIcon} alt='image' /> 
                                                              <Typography className={classes.imageText} onClick={() => downloadDocuments(key.documentName, key?.documentId)}>{shortText(key.documentName)} </Typography>
                                                              
                                                                <DeleteIcon color="action" onClick={() => deleteDoc(key?.documentId, ind, key.fileName)} style={{cursor: 'pointer', color: '#4D4D4D', marginRight: 10}}></DeleteIcon>                                
                                                          </Box>
                                                        </Box>
                                                    </Grid>
                                                    )})}
                                              </Grid> 

                                              </Box>
                                              {loader ?
                                                <Button disabled={true} type='submit' className={classes.subBtn} variant="contained" color='primary'>
                                                  <CircularProgress color='primary' style={{ height: '24px', width: '24px' }} />
                                                </Button> :
                                                <Button
                                                  onClick={() => handleSubmit(index, key, key?.userComment)}
                                                  className={classes.subBtn}
                                                  variant="contained"
                                                  disabled={!userComment || isAdminCheck()}
                                                  color="primary">
                                                  SUBMIT </Button>}
                                            </Box>
                                          </Grid>
                                          }

                                          <Grid item xs={12} sm={12} md={6} style={{ display: 'flex' }}>
                                            <Grid xs={2} sm={2} md={1}>
                                              {commentData.commentByAgent && <Typography className={classes.nameTag}>
                                                {<span className='text'>AC</span>}
                                              </Typography>}
                                              {!commentData.commentByAgent && <Typography className={classes.nameTagUN}>
                                                <span className='text'>{getAbbrevation(userName)}</span>
                                              </Typography>}
                                            </Grid>

                                            <Grid xs={10} sm={10} md={10} style={{ display: 'flex' }}>
                                              <Typography className={classes.headingText}>{commentData.commentByAgent ? commentData.agentName : userName}</Typography>
                                              <Typography className={classes.headingDate}>{moment(commentData.createdDateTime).format('MM/DD/YYYY')}</Typography>
                                            </Grid>
                                          </Grid>

                                          <Grid item xs={12} sm={12} md={12} >
                                           
                                          {/* <Typography className={classes.agentComment} dangerouslySetInnerHTML={{ __html: commentData.comment }}></Typography> */}

                                            <Box className={classes.agentComment}>
                                                {commentData?.isCommentExpanded ? (
                                                  <span
                                                          dangerouslySetInnerHTML={{ __html: commentData.comment }}
                                                        />
                                                      ) : (
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html: (commentData.comment.length > 250) ?  `${commentData.comment.substring(0, 250)}...` : 
                                                      commentData.comment,
                                                    }}
                                                  />
                                                )}
                                            
                                                {commentData.comment.length > 250 && (
                                            <span
                                              onClick={() => handleViewMore(index, i, !commentData?.isCommentExpanded)}
                                              className={classes.view}
                                            >
                                                    {commentData?.isCommentExpanded ? 'View Less' : 'View More'}
                                            </span>
                                                )}
                                            </Box>
                                            
                                            <Typography className={classes.documents}>
                                              {commentData?.documents?.map((doc) => (
                                                <Typography className={classes.fileName} onClick={() => downloadDocuments(doc.documentName, doc?.documentId)}><img src={doc.documentName.includes('.pdf') ? pdfIcon : imageIcon} style={{ marginRight: '10px' }} />{doc.documentName}</Typography>
                                              ))}
                                            </Typography>
                                           
                                          </Grid>
                                        </Grid>

                                      </Box>
                                    </Grid>
                                  </Grid>)
                                })}
                              </Box>}
                            </Box>}
                          </Box>

                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  )
                })}

                <Grid container>
                  <Grid item md={8} xs={12} lg={8}>
                    <Box className={classes.warningBox}>
                      <img src={infoIcon} style={{ height: '16px' }} />
                      <Box className={classes.disappeared}>The ticket(s) will be archived from the "Support Tickets" history post 90 days from "Completed" status.</Box>
                    </Box>
                  </Grid>

                  <Grid item md={4} xs={12} lg={4}>
                    <Box className={classes.pagination}>
                      <Pagination count={totalPages} page={page} onChange={handleChange} 
                   />
                    </Box>
                  </Grid>
                </Grid>

              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box >
      <TicketReopenPopup open={reopenPopup} accountNumber={props.accountNumber} closeReopenPopup={closeReopenPopup} submitReopenTicket={submitReopenTicket} selectedLoan={props.selectedLoan} supportTicketId={supportTicketId}/>

      <ReopenTicketSuccessPopup
        open={reopenTicketSuccess}
        handleGotIt={handleGotIt}
        supportTicketDetails={supportTicketDetails}
        screen='support'
      />

       <DeleteConfirmation
          open={deleteStatus}
          popupText={{statusTitle:'Deletion Request',statusBody:'Are you sure you really want to delete this document?'}}
          handleCancelIcon={handleClose}
          handleSubmitClose={handleClose}
          handleSubmit={handleDeleteDoc}
        />

        <FileSizeAlert
          open={alertStatus}
          handleAlertClose={handleAlertClose}
          file={file}
        />

         <FileExtensionAlert
            open={allowedExtensionsStatus}
            handleExtensionAlertClose={handleExtensionAlertClose}
            file={file}
          />

        {feedbackStatus && <SupportFeedback open={feedbackStatus} ticketID={ticketId} handleCancelIcon={handleCancelIcon} handleFeedbackSubmit={handleFeedbackSubmit}/> }

    </CssBaseline >
  )
})
